import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgTheme = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M22.998 15.676c.506 0 .916.41.916.916v6.163c0 .506-.41.916-.916.916h-7.843a.917.917 0 0 1-.917-.916v-6.163c0-.506.41-.916.917-.916Zm-12.324-3.361c.506 0 .916.41.916.916v9.524c0 .506-.41.916-.916.916H2.83a.917.917 0 0 1-.917-.916V13.23c0-.506.41-.916.917-.916Zm11.405 5.193h-6.008v4.33h6.008v-4.33ZM9.755 14.147H3.748v7.69h6.007v-7.69ZM22.998 1.671c.506 0 .916.41.916.917v9.523c0 .506-.41.917-.916.917h-7.843a.917.917 0 0 1-.917-.917V2.588c0-.506.41-.917.917-.917Zm-.919 1.834h-6.008v7.689h6.008v-7.69ZM10.674 1.67c.506 0 .916.41.916.917V8.75c0 .506-.41.917-.916.917H2.83a.917.917 0 0 1-.917-.917V2.588c0-.506.41-.917.917-.917Zm-.919 1.834H3.748v4.328h6.007V3.505Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgTheme)
const Memo = memo(ForwardRef)
export default Memo
